import React from 'react'
import { Link } from 'react-router'
import PracticeSearch from '../practice/PracticeSearch.jsx'
const style = {
	margin: '8px 0',
	'borderRadius': '4px',
	cursor: 'pointer'
}




const HomeContent = ({ User, setAsOwner }) => {

	let AdminOptions, OwnerOptions, TherapistOptions, ParentOptions;
	let newUserMessage = <div className="card primary greetingPrimary" style={style} onClick={setAsOwner}>

		<div className="middle">
			<h6 className="center">Are you a practice owner?</h6>
			<p className="center" >Register your practice now</p>
		</div>
		<br />
	</div>;

	if (User.admin) {
		AdminOptions = <li >
			<h6>Admin</h6>
			<ul className="md-list">
				<li ><Link to='/admin/users' >Users</Link></li>
				<li ><Link to='/admin/practices' >Practices</Link></li>
				<li ><Link to='/admin/therapy_areas' >Therapy Areas</Link></li>
				<li ><Link to='/admin/therapy_categories' >Therapy Categories</Link></li>
				<li ><Link to='/admin/videos' >Videos</Link></li>
			</ul>
		</li>;
		//newUserMessage = null;
	}

	if (User.owner) {
		OwnerOptions = <li>
			<h6>Practice Admin</h6>
			<ul className="md-list">
				{User.ownPractices.map(practice => (
					<li key={practice._id}>
						<Link to={`/practice_admin/${practice.slug}`}>{practice.name}</Link>
					</li>
				)
				)}
			</ul>
		</li>
		//newUserMessage = null;
	}

	if (User.therapist) {
		TherapistOptions = <li>
			<ul>
				<li ><Link to='/therapists'>Therapist</Link></li>
			</ul>
		</li>
		//newUserMessage = null;
	}

	if (User.parent) {
		ParentOptions = <li>
			<ul>
				<li ><Link to='/parents'>Parent</Link></li>
			</ul>
		</li>
		//newUserMessage = null;
	}


	return (
		<main className="main " >
			{User._id ? (<div className="page pageLanding mb8">
				<h5 className="primary_color center">
					Welcome to SpecialT!
					</h5>
				<p className="center quiet">Thank you for signing up!</p>
				<PracticeSearch admin={User.admin ? true : false} />
				<br />
				{newUserMessage}
				<br /><br />
				<ul className="md-list divider wide">
					{ParentOptions}
					{TherapistOptions}
					{OwnerOptions}
					{AdminOptions}</ul>
			</div>) :
				(<div>Redirecting ...</div>)}
		</main>)
}

export default HomeContent;



// WEBPACK FOOTER //
// ./src/components/home/HomeContent.jsx